import { apiSlice } from "./apiSlice";

export const announcementApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAnnouncement: builder.mutation({
      query: (announcementData) => ({
        url: "/announcements/createAnnouncement",
        method: "POST",
        body: announcementData,
      }),
      invalidatesTags: ["Announcement"],
    }),

    deleteAnnouncement: builder.mutation({
      query: (id) => ({
        url: `/announcements/deleteAnnouncement/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Announcement"],
    }),

    updateAnnouncement: builder.mutation({
      query: ({ announcementData, id }) => ({
        url: `/announcements/updateAnnouncement/${id}`,
        method: "PATCH",
        body: announcementData,
      }),
      invalidatesTags: ["Announcement"],
    }),

    getAllAnnouncements: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/announcements/getAllAnnouncementsDashboard?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Announcement"],
    }),
    getAnnouncementById: builder.query({
      query: (id) => ({
        url: `/announcements/getAnnouncementById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useGetAllAnnouncementsQuery,
  useGetAnnouncementByIdQuery,
} = announcementApi;
